import axios from 'axios';

// PUT
// /ewosapi/v2/planandprognosis/default-profile/fishgroup/{fishGroupId}/harvesttarget
export const putFishGroupHarvestTarget = async (
  fishGroupId: string,
  request: { date: string; weight: number },
  index: number
): Promise<number> => {
  await axios.put(`/ewosapi/v2/planandprognosis/default-profile/fishgroup/${fishGroupId}/harvesttarget`, request);
  return index;
};
